<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="metaTemplatesMetaModal"
  aria-hidden="true" [config]="{ignoreBackdropClick: true, keyboard: false}">
  <div class="modal-dialog modal-xl">
    <div class="card modal-content">
      <div class="header">
        <button type="button" class="close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h2>Templates na Meta</h2>
      </div>
      <div class="modal-body">
        <div class="alert alert-info" *ngIf="templates.length === 0">
          Nenhum template foi retornado pela Meta.
        </div>

        <div class="row" *ngIf="templates.length > 0">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th width="90">Idioma</th>
                    <th width="130">Categoria</th>
                    <th width="120">Status</th>
                    <th width="110">Qualidade</th>
                    <th>Prévia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let template of templates">
                    <td>
                      <strong>{{template.name}}</strong>
                      <br>
                      <small class="text-muted">{{template.id}}</small>
                    </td>
                    <td>{{template.language}}</td>
                    <td>{{template.category}}</td>
                    <td>{{template.status}}</td>
                    <td>{{getQualityScore(template)}}</td>
                    <td>
                      <div class="meta-preview">
                        <div class="meta-preview-header" *ngIf="getHeader(template)">
                          <strong>{{getHeader(template).format}}</strong>
                          <span *ngIf="getHeader(template).text"> - {{getHeader(template).text}}</span>
                        </div>
                        <div class="meta-preview-body" *ngIf="getBody(template)">
                          {{getBody(template).text}}
                        </div>
                        <div class="meta-preview-footer text-muted" *ngIf="getFooter(template)">
                          {{getFooter(template).text}}
                        </div>
                        <div class="meta-preview-buttons" *ngIf="getButtons(template).length > 0">
                          <span class="label bg-grey" *ngFor="let button of getButtons(template)">
                            {{button.text}} · {{button.type}}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <button mat-stroked-button type="button" (click)="close()" class="button-row">
          <span>Fechar</span>
        </button>
      </div>
    </div>
  </div>
</div>
